<template>
    <div class="input-container">
        <view-selector />
        <input-sample-dashboard 
        :style="showSampleDashboard"
        :studySelected="studySelected" />
        <input-heatmap :style="showHeatmap" 
        :tabReset="'tab-1'"
        :studySelected="studySelected"/>
        <input-boxplot :style="showBoxplot" :studySelected="studySelected"/>
        <input-scatterplot :style="showScatterplot" :studySelected="studySelected"/>
        <!-- <input-quality-control :style="showQualityControl" /> -->
        <!-- <input-histology-viewer :style="showHistologyViewer" /> -->
        <input-pfs-curveplot :style="showPfsCurveplot" :studySelected="studySelected"/>
    </div>
</template>

<script>
import InputBoxplot from './Boxplot/InputBoxplot.vue'
import InputHeatmap from './Heatmap/InputHeatmap.vue'
// import InputHistologyViewer from './InputHistologyViewer.vue'
// import InputQualityControl from './InputQualityControl.vue'
import InputSampleDashboard from './InputSampleDashboard.vue'
import InputScatterplot from './Scatterplot/InputScatterplot.vue'
import InputPfsCurveplot from './PFSCurveplot/InputPfsCurveplot.vue'
import ViewSelector from './ViewSelector.vue'

export default {
    components: {
        InputBoxplot,
        InputHeatmap,
        // InputHistologyViewer,
        // InputQualityControl,
        InputSampleDashboard,
        InputScatterplot,
        InputPfsCurveplot,
        ViewSelector,
    },
    name: "input-container",
    // props: ['studySelected'],
    data: () => ({
        // studySelected: this.studySelected
    }),
    computed: {
        studySelected() { 
            // console.log('studySelected', this.$route.path)
            if (this.$route.path === '/pcc') {
                return 'PCC'
            } else {
                return 'PTRC'
            }
        },
        showBoxplot() { return this.view === 'Boxplot' ? "" : "display: none;" },
        showDemo() { return this.view === 'Demo' ? "" : "display: none;" },
        showHeatmap() { return this.view === 'Heatmap' ? "" : "display: none;" },
        showIprofun() { return this.view === 'Iprofun' ? "" : "display: none;" },
        showSampleDashboard() { return this.view === 'Sample dashboard' ? "" : "display: none;" },
        showScatterplot() { return this.view === 'Scatterplot' ? "" : "display: none;" },
        showQualityControl() { return this.view === 'Quality control' ? "" : "display: none;" },
        showHistologyViewer() { return this.view === 'Histology viewer' ? "" : "display: none;" },
        showPfsCurveplot() { 
            // console.log('showPfsCurveplot', this.view)
            return this.view === 'Survival curve plot' ? "" : "display: none;" },
        view() { return this.$store.state.view },
    }
}
</script>

<style scoped>
    .input-container {
        max-width: 450px;
        min-width: 450px;
        border-top: none;
        padding-top: 8px;
        overflow-y: scroll;
        border-right: solid 1px lightgray;
}

    .input-container > div {
        margin-bottom: 1em;
    }

    .mssm-logo {
        margin: 2em;
    }

    .logo {
        margin: 0 auto;
        display: flex;
        flex-direction: row;
        justify-content: center;
        position: fixed;
        bottom: 0;
        /* left: 100px; */
    }
</style>